import { api } from 'api';
import { call, put, SagaReturnType } from 'redux-saga/effects';
import { forecastActions as aggregatedForecastActions } from 'store/aggregated/forecast';
import { JwtFeature } from 'utility/jwt';

import { operationWrapper } from './operationWrapper';

// Triggers a server-side week-ahead forecast and adds each returned projection
// to the aggregated forecast domain. The api.forecastWeek call is currently a
// stub returning [] — the structure is kept so re-enabling the real endpoint
// is a single-file swap once it lands in the OpenAPI spec.
export function* forecastWeek(args: { zoneId: string; date: Time.Day }) {
  function* work(tenantId: string) {
    const projections: SagaReturnType<typeof api.forecastWeek> = yield call(
      api.forecastWeek,
      { tenantId, ...args },
    );

    for (const projection of projections) {
      yield put(aggregatedForecastActions.add(projection));
    }
  }

  yield call(operationWrapper, work, JwtFeature.Forecast);
}
